'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _regeneratorRuntime = require('@babel/runtime/regenerator');
var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var reactPlacesAutocomplete = require('react-places-autocomplete');
var _forEach = require('lodash/forEach');
var _forOwn = require('lodash/forOwn');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _forEach__default = /*#__PURE__*/_interopDefaultLegacy(_forEach);
var _forOwn__default = /*#__PURE__*/_interopDefaultLegacy(_forOwn);

var ADDRESS_COMPONENT_MAPPINGS = {
  subpremise: 'subpremise',
  streetNumber: 'street_number',
  route: 'route',
  country: 'country',
  state: 'administrative_area_level_1',
  city: 'locality',
  postcode: 'postal_code'
};
function geocodeAddress(address) {
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee2(res, rej) {
      var results, latLng;
      return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return reactPlacesAutocomplete.geocodeByAddress(address);

            case 3:
              results = _context2.sent;
              _context2.next = 6;
              return reactPlacesAutocomplete.getLatLng(results[0]);

            case 6:
              latLng = _context2.sent;
              res({
                results: results,
                latLng: latLng
              });
              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);

              if (_context2.t0 === 'OVER_QUERY_LIMIT') {
                setTimeout( /*#__PURE__*/_asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee() {
                  var result;
                  return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          result = geocodeAddress(address);
                          res(result);

                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })), 1000);
              } else {
                rej(_context2.t0);
              }

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}
var mapAddressComponents = function mapAddressComponents(addressComponents) {
  var components = {};

  _forEach__default["default"](addressComponents, function (component) {
    _forOwn__default["default"](ADDRESS_COMPONENT_MAPPINGS, function (mapping, key) {
      var _component$types;

      if ((component == null ? void 0 : (_component$types = component.types) == null ? void 0 : _component$types[0]) === mapping) {
        components[key] = {
          longName: component.long_name,
          shortName: component.short_name
        };
      }
    });
  });

  return components;
};
var parseAddress = function parseAddress(addressComponents) {
  var requestData = {};

  if (addressComponents) {
    var address = mapAddressComponents(addressComponents);

    if (address.route) {
      requestData.address = "" + (address.subpremise ? address.subpremise.longName + "/" : '') + ((address.streetNumber ? address.streetNumber.longName : '') + " ") + ("" + address.route.longName);
    }

    if (address.country) {
      requestData.countryCode = address.country.shortName;
      requestData.country = address.country.longName;
    }

    requestData.state = address.state ? address.state.longName : null;
    requestData.city = address.city ? address.city.longName : null;
    requestData.postcode = address.postcode ? address.postcode.longName : null;
  }

  return requestData;
};
var getAddressFromPlaceId = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee3(placeId) {
    var results, result, latLng, addressComponents;
    return _regeneratorRuntime__default["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return reactPlacesAutocomplete.geocodeByPlaceId(placeId);

          case 2:
            results = _context3.sent;
            result = results == null ? void 0 : results[0];
            _context3.next = 6;
            return reactPlacesAutocomplete.getLatLng(result);

          case 6:
            latLng = _context3.sent;
            addressComponents = parseAddress(result == null ? void 0 : result.address_components);
            return _context3.abrupt("return", {
              addressComponents: addressComponents,
              latLng: latLng
            });

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getAddressFromPlaceId(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

exports.geocodeAddress = geocodeAddress;
exports.getAddressFromPlaceId = getAddressFromPlaceId;
exports.mapAddressComponents = mapAddressComponents;
exports.parseAddress = parseAddress;
